"use client";
import React from "react";

const GetstartedBannerImage = () => {
  return (
    <div className="">
      <video autoPlay loop muted playsInline width={484} height={264}>
        <source src="/video/Camera_tampering_detection.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default GetstartedBannerImage;
